<template>
  <div class="collapsible-header">
    <i class="material-icons">casino</i>Bot rolled a {{ botRoll }}
  </div>
  <div class="collapsible-header" v-if="botRoll != 6">
    <i class="material-icons">input</i>Set aside card #{{ botRoll }}
  </div>
</template>

<script>
import { defineComponent } from "vue";
import store from "../store.js";

export default defineComponent({
  setup() {
    function getRandomInt(max) {
      return Math.floor(Math.random() * max) + 1;
    }
    if (store.bot.canRoll) {
      store.bot.roll = getRandomInt(6);
      store.bot.canRoll = false;
    }

    return {
      botRoll: store.bot.roll,
    };
  },
});
</script>

<style></style>
